import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import Media from 'reactstrap/lib/Media';

import closeImg from '../../../images/icons/close.png';
import davana from '../../../images/Menu/davana.svg';
import davana1000 from '../../../images/Menu/davana_1000.svg';
// import davana from '../../../images/Menu/davana.svg';
import * as constants from '../../../constants/constants';

import {
  claimChestBonus,
  claimAdventBonus,
  claimGiftLink,
  closeEmailVerifyBonusModal,
} from '../../../actions/member';

class BonusModals extends React.Component {
    static propTypes = {
      showChestBonusModal: PropTypes.bool,
      showAdventBonusModal: PropTypes.bool,
      showGiftLinkModal: PropTypes.bool,
      showEmailVerifyBonusModal: PropTypes.bool,
      t: PropTypes.func.isRequired,
      claimChestBonusFunc: PropTypes.func.isRequired,
      claimAdventBonusFunc: PropTypes.func.isRequired,
      claimGiftLinkFunc: PropTypes.func.isRequired,
      closeEmailVerifyBonus: PropTypes.func.isRequired,
      newVersion: PropTypes.string,
      // tutorialShown: PropTypes.bool,
      holidayModalOpen: PropTypes.bool,
      toggleBonusModal: PropTypes.func.isRequired,
      openModal: PropTypes.bool,
      fontMode: PropTypes.string,
      holidayTest: PropTypes.bool,
      selectedTestHoliday: PropTypes.shape({}),
      cancelHolidayTest: PropTypes.func.isRequired,
    }

    static defaultProps = {
      showChestBonusModal: false,
      showAdventBonusModal: false,
      showGiftLinkModal: false,
      showEmailVerifyBonusModal: false,
      newVersion: '',
      // tutorialShown: false,
      holidayModalOpen: false,
      openModal: false,
      fontMode: constants.FONT_MODE.normal,
    }

    componentDidUpdate(prevProps) {
      const { showChestBonusModal, showAdventBonusModal, showGiftLinkModal, toggleBonusModal } = this.props;

      if ((!prevProps.showChestBonusModal && showChestBonusModal) || (!prevProps.showAdventBonusModal && showAdventBonusModal) || (!prevProps.showGiftLinkModal && showGiftLinkModal)) {
        toggleBonusModal(true);
      }
    }

    claimChestBonusFuncA = () => {
      const { claimChestBonusFunc, toggleBonusModal } = this.props;
      claimChestBonusFunc();
      toggleBonusModal(false);
    }

    claimAdventBonusFuncA = () => {
      const { claimAdventBonusFunc, toggleBonusModal } = this.props;
      claimAdventBonusFunc();
      toggleBonusModal(false);
    }

    claimTestAdventBonusFuncA = () => {
      const { claimAdventBonusFunc, toggleBonusModal, cancelHolidayTest } = this.props;
      cancelHolidayTest();
      claimAdventBonusFunc();
      toggleBonusModal(false);
    }

    claimGiftLinkFuncA = () => {
      const { claimGiftLinkFunc, toggleBonusModal } = this.props;
      claimGiftLinkFunc();
      toggleBonusModal(false);
    }

    render() {
      const {
        showChestBonusModal,
        showAdventBonusModal,
        showGiftLinkModal,
        t,
        newVersion,
        openModal,
        holidayModalOpen,
        fontMode,
        showEmailVerifyBonusModal,
        closeEmailVerifyBonus,
        holidayTest,
        selectedTestHoliday,
      } = this.props;

      console.log('showGiftLinkModal', showGiftLinkModal, newVersion, constants.NEW_VERSION, openModal, holidayModalOpen);

      // console.log('Bonus modals', showEmailVerifyBonusModal);

      if (holidayTest) {
        if (selectedTestHoliday?.id === constants.ADVENT_BONUS_MODAL) {
          return (
            <Modal container={'div > div'} isOpen toggle={this.claimTestAdventBonusFuncA} size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('claimAdventBonus')}
                  {' '}
                </div>
                <Media src={davana1000} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={this.claimTestAdventBonusFuncA}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
      }

      if (newVersion && newVersion >= constants.NEW_VERSION && !openModal && !holidayModalOpen) {
        if (showChestBonusModal) {
          return (
            <Modal container={'div > div'} isOpen toggle={this.claimChestBonusFuncA} size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('claimChestBonus')}
                  {' '}
                </div>
                <Media src={davana} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={this.claimChestBonusFuncA}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
        if (showAdventBonusModal) {
          return (
            <Modal container={'div > div'} isOpen toggle={this.claimAdventBonusFuncA} size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('claimAdventBonus')}
                  {' '}
                </div>
                <Media src={davana1000} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={this.claimAdventBonusFuncA}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
        if (showGiftLinkModal) {
          return (
            <Modal container={'div > div'} isOpen toggle={this.claimGiftLinkFuncA} size="lg" className={`holiday-modal holidays-modal old-modal root-font-${fontMode}`}>
              <ModalBody className="holiday-modal-body">
                <div>
                  {' '}
                  {t('claimGiftLink')}
                  {' '}
                </div>
                <Media src={davana1000} className="holiday-modal-img-old" />
              </ModalBody>
              <ModalFooter className="holiday-modal-footer">
                <Button color="link" className="holiday-modal-footer-button" onClick={this.claimGiftLinkFuncA}>{t('thanks')}</Button>
              </ModalFooter>
            </Modal>
          );
        }
        
        if (showEmailVerifyBonusModal) {
          return (
            <Modal container={'div > div'} isOpen={showEmailVerifyBonusModal} toggle={closeEmailVerifyBonus} size="md" className="old-modal">
              <ModalHeader
                toggle={closeEmailVerifyBonus}
                className={`notification-header tutorial-result-header-${fontMode}`}
                close={
                  <Media src={closeImg} className="notification-header-close" alt="X" onClick={closeEmailVerifyBonus} />
                }
              >{t('common:common.congratulations')}</ModalHeader>
              <ModalBody>
                <div className={`d-flex align-items-center flex-column text-center tutorial-result-section-${fontMode}`}>
                  {t('updateProfile:earnedReward')}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button className={`modal-footer-button mb-3 tutorial-result-button-${fontMode}`} color="secondary" onClick={closeEmailVerifyBonus}>
                  {t('common:common.ok')}
                </Button>
              </ModalFooter>
            </Modal>
          );
        }
      }
      return null;
    }
}

const mapStateToProps = state => ({
  showChestBonusModal: state.member.showChestBonusModal || false,
  showAdventBonusModal: state.member.showAdventBonusModal || false,
  showGiftLinkModal: state.member.showGiftLinkModal || false,
  showEmailVerifyBonusModal: state.member.showEmailVerifyBonusModal || false,
  newVersion: state.member.newVersion || null,
  // tutorialShown: state.member.tutorialShown || null,
});

const mapDispatchToProps = {
  claimChestBonusFunc: claimChestBonus,
  claimAdventBonusFunc: claimAdventBonus,
  claimGiftLinkFunc: claimGiftLink,
  closeEmailVerifyBonus: closeEmailVerifyBonusModal,
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['holiday', 'updateProfile', 'common'])(BonusModals));
